import styles from "./Header.module.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBars } from "@fortawesome/free-solid-svg-icons";
import { useState } from "react";

export default function HeaderMenu() {
  const [showHeaderMenu, setShowHeaderMenu] = useState(false);

  const Bars = (
    <div
      className={styles.bars}
      onClick={() => setShowHeaderMenu(!showHeaderMenu)}
    >
      <FontAwesomeIcon size="3x" color="#ffcc00" icon={faBars} />
      {showHeaderMenu && (
        <div className={styles.barMenu}>
          <a className={styles.link} href="/">
            <div className={styles.barMenuItem}>Home</div>
          </a>
          <a className={styles.link} href="/about">
            <div className={styles.barMenuItem}>About Pujari</div>
          </a>
          <a className={styles.link} href="/details">
            <div className={styles.barMenuItem}>What We Do</div>
          </a>
          <a className={styles.link} href="/contact">
            <div className={styles.barMenuItem}>Contact</div>
          </a>
        </div>
      )}
    </div>
  );

  return (
    <div className={styles.headerMenu}>
      <a className={styles.link} href="/">
        <div className={styles.linkMenu}>Home</div>
      </a>
      <a className={styles.link} href="/about">
        <div className={styles.linkMenu}>About Pujari</div>
      </a>
      <a className={styles.link} href="/details">
        <div className={styles.linkMenu}>What We Do</div>
      </a>
      <a className={styles.link} href="/contact">
        <div className={styles.linkMenu}>Contact</div>
      </a>
      {Bars}
    </div>
  );
}
